<mat-card
    appearance="outlined"
    class="riege-card"
    [ngClass]="classes"
    [attr.data-testid]="data.id ? 'riege-card-'+ data.id : 'default'">
    <ng-container *ngTemplateOutlet="data.href ? linkedCard : basicCard"></ng-container>

    <ng-template #linkedCard>
        <ng-container *ngTemplateOutlet="data.href?.startsWith('http') ? externalLink : internalLink"></ng-container>

        <ng-template #externalLink>
            <a class="link--box-shadow link--flex-streched" [href]="[ data.href ]" target="_blank">
                <ng-template *ngTemplateOutlet="cardContent"></ng-template>
            </a>
        </ng-template>

        <ng-template #internalLink>
            <a class="link--box-shadow link--flex-streched" [routerLink]="[ data.href ]">
                <ng-template *ngTemplateOutlet="cardContent"></ng-template>
            </a>
        </ng-template>
    </ng-template>

    <ng-template #basicCard>
        <ng-template *ngTemplateOutlet="cardContent"></ng-template>
    </ng-template>
</mat-card>

<ng-template #cardContent>
    <img *ngIf="data.image" mat-card-image src="{{ data.image }}" alt="" />
    <mat-card-content [ngClass]="{'has-title-icon' : data.icon}">
        <p *ngIf="data.date" class="mat-card__overline">{{ data.date | date: 'mediumDate' }}</p>
        <div class="mat-card-content__icon" *ngIf="data.icon">
            <mat-icon class="riege-icon" alt="" aria-hidden="true" fontIcon="{{ data.icon }}"></mat-icon>
        </div>
        <mat-card-title *ngIf="data.title" [ngClass]="{'reset-margin--bottom' : !data.text}"
            >{{ data.title }}</mat-card-title
        >
        <p *ngIf="data.text" [ngClass]="{'reset-margin--bottom' : !data.action}">{{ data.text | ellipsis: 120 }}</p>
    </mat-card-content>

    <mat-card-actions *ngIf="data.action">
        <ng-content select="[action-slot]"></ng-content>
    </mat-card-actions>
</ng-template>
